import { toast } from "react-toastify";

const sendSuccessToast = (message: string) => {
  toast(message, {
    type: "success",
  });
  return;
};
export default sendSuccessToast;
